
import React, {Component} from "react";
import cx from "classnames";

class CratioToolBarOption extends Component {
    render() {
        let {customButtons, isHtmlView} = this.props;

        return (
            <div className={cx("rdw-editor-toolbar", {"toolbarClassName custom-toolbar-box" : !isHtmlView})}>
                {
                    customButtons.map((value) => {
                        let name = value.name;
                        let label = value.label;
                        let handler = value.handler;
                        let classname = value.classname;
                        let mainClass = value.mainClass;
                        let isDisabled = value.isDisabled;
                        let isView = value.isView;
                        let title = value.title;
                        if(!isView){
                            return;
                        }
                        if(isDisabled){
                            classname += " rdw-option-disabled";
                        }
                        return(
                            <>
                                <div className={mainClass}>
                                    <div 
                                        onClick={isDisabled ? false : e => {handler(name)}} 
                                        className={classname}
                                        title = {title}
                                    >
                                        {label}
                                    </div>
                                </div>
                            </>
                        )
                    })
                }
            </div>
        );
    }
}
export default CratioToolBarOption;